// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"0e950abe","213":"4889383f","239":"13d3f169","557":"2069d191","732":"7ba21433","762":"9823b2e5"}[chunkId] + ".chunk.js";
};